/* Salt Theory — minimal theme JS */
(function () {
  document.documentElement.classList.remove('no-js');

  // Subtle header shadow once scrolled
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 12) {
        header.style.boxShadow = '0 1px 0 rgba(21,19,14,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Size guide modal
  var sg = document.querySelector('[data-size-guide]');
  if (sg) {
    var openBtns = document.querySelectorAll('[data-size-guide-open]');
    var openSg = function () { sg.hidden = false; document.body.style.overflow = 'hidden'; };
    var closeSg = function () { sg.hidden = true; document.body.style.overflow = ''; };
    openBtns.forEach(function (b) { b.addEventListener('click', openSg); });
    sg.querySelectorAll('[data-size-guide-close]').forEach(function (b) { b.addEventListener('click', closeSg); });
    sg.addEventListener('click', function (e) { if (e.target === sg) closeSg(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !sg.hidden) closeSg(); });
  }
})();
